module.exports = __webpack_public_path__ + "static/media/location.c963f029.svg";


//////////////////
// WEBPACK FOOTER
// ./src/pages/Delivery/components/PickUpModal/images/location.svg
// module id = 1605
// module chunks = 0